class B2BAccountMenu extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    if (!this.details) return;

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    document.addEventListener('click', this.handleDocumentClick);
    this.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleDocumentClick);
    this.removeEventListener('keydown', this.handleKeydown);
  }

  handleDocumentClick(event) {
    if (this.details?.open && !this.contains(event.target)) {
      this.details.removeAttribute('open');
    }
  }

  handleKeydown(event) {
    if (event.key !== 'Escape' || !this.details?.open) return;
    this.details.removeAttribute('open');
    this.details.querySelector('summary')?.focus();
  }
}

if (!customElements.get('b2b-account-menu')) {
  customElements.define('b2b-account-menu', B2BAccountMenu);
}
